var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackArrow = function SvgBlackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.685 38.685",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.343 0-3.422 3.421 13.5 13.5H0v4.839h29.425l-13.5 13.5 3.421 3.421 19.339-19.338Z",
    className: "arrow"
  })));
};
export default SvgBlackArrow;